import { useEffect, useRef } from "react";

export const useMobileMenu = (open, close) => {
  const panelRef = useRef(null);
  const toggleRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const panel = panelRef.current;
    const returnTarget = toggleRef.current;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const backgrounds = [document.getElementById("main-content"), document.querySelector("footer")].filter(Boolean);
    const previousInert = backgrounds.map(element => element.inert);
    backgrounds.forEach(element => { element.inert = true; });
    const controls = () => [...panel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
    controls()[0]?.focus({ preventScroll: true });
    const keydown = event => {
      if (event.key === "Escape") { event.preventDefault(); close(); }
      if (event.key !== "Tab") return;
      const items = controls();
      const first = items[0]; const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    };
    const desktop = window.matchMedia("(min-width: 1280px)");
    const resize = () => { if (desktop.matches) close(); };
    document.addEventListener("keydown", keydown);
    desktop.addEventListener("change", resize);
    return () => {
      document.body.style.overflow = previousOverflow;
      backgrounds.forEach((element, i) => { element.inert = previousInert[i]; });
      document.removeEventListener("keydown", keydown);
      desktop.removeEventListener("change", resize);
      if (!desktop.matches) returnTarget?.focus({ preventScroll: true });
    };
  }, [open, close]);
  return { panelRef, toggleRef };
};